import { render, staticRenderFns } from "./model.vue?vue&type=template&id=2e9283be&scoped=true&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"
import style0 from "./model.vue?vue&type=style&index=0&id=2e9283be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9283be",
  null
  
)

export default component.exports